import Vue from 'vue';
import AppInner from './Layouts/AppInner.vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

import HomeApplicant from './components/Applicant/HomeApplicant.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [{
      path: '/Home',
      name: 'Home',
      component: Home,
      meta: {
        BannerClass: 'banner',
        BoxClass: 'box',
      },
    },
    

    {
      path: '/',
      component: Home,
    },
    {
      path: '/HomeApplicant',
      component: HomeApplicant,
      meta: {
        layout: 'default'
      }
    },
    {
      path: '/login',
      component: Login,
    },

    {
      meta: {AppInner},
      path: '/register',
      component: Register,
    },
    {
      path: '/DataApp',
    //  meta: {Layouts: AppInner},
      name: 'Application',
      meta: {
        BannerClass: 'banner2',
        BoxClass: 'box2',
      },
      component: () => import( /* webpackChunkName: "DataApp" */ './views/Applicant/DataApp.vue')
    },
   
    {
      path: '/Tasks',
      name: 'Tasks',
      meta: {
        BannerClass: 'banner2',
        BoxClass: 'box2',
      },

      component: () => import( /* webpackChunkName: "Tasks" */ './views/Applicant/Tasks.vue')
    },
    {
      path: '/ForgetPassword',
      name: 'ForgetPassword',

      component: () => import( /* webpackChunkName: "ForgetPassword" */ './views/ForgetPassword.vue')

    },

    {
      path: '/Trems',
      name: 'Trems',

      component: () => import( /* webpackChunkName: "Trems" */ './views/Applicant/Trems.vue')
    },
    {
      path: '/MyApplication',
      name: 'MyApplication',


      component: () => import( /* webpackChunkName: "MyApplication" */ './views/Applicant/MyApplication.vue')
    },
    {
      path: '/Mail',
      name: 'Mail',
      meta: {
        BannerClass: 'banner2',
        BoxClass: 'box2',
      },

      component: () => import( /* webpackChunkName: "Mail" */ './views/Applicant/Mail.vue')
    },
    {
      path: '/profile',
      name: 'Profile',
      meta: {
        BannerClass: 'banner2',
        BoxClass: 'box2',
      },
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Profile" */ './views/Applicant/Profile.vue')
    },
    {
      path: '/Employees',
      name: 'Employee',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Employee" */ './views/Emplyees/Employee.vue')
    },
    {
      path: '/Admission',
      name: 'Admission',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Admission" */ './views/Admission/Admission.vue')
    },
    {
      path: '/Applicant',
      name: 'Applicant',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/Applicant.vue')
    },
    {
      path: '/Fawry',
      name: 'Fawry',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/Fawry.vue')
    },
    {
      path: '/BMPayment',
      name: 'BMPayment',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/BMPayment.vue')
    },
    {
      path: '/BMPaymentSuccess',
      name: 'BMPaymentSuccess',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/BMPaymentSuccess.vue')
    },

    {
      path: '/BMPaymentError',
      name: 'BMPaymentSError',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/BMPaymentError.vue')
    },
    {
      path: '/ProcessPayment',
      name: 'Process Payment',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/ProcessPayment.vue')
    },
    // {
    //   path: '/MizaPayment',
    //   name: 'Miza Payment',
    //   // lazy-loaded
    //   component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/MizaPayment.vue')
    // },
    // {
    //   path: '/MizaProcessPayment',
    //   name: 'Process Payment',
    //   // lazy-loaded
    //   component: () => import( /* webpackChunkName: "Applicant" */ './views/Applicant/MizaProcessPayment.vue')
    // },
    {
      path: '/Wallet',
      name: 'Wallet',
      meta: {
        BannerClass: 'banner2',
        BoxClass: 'box2',
      },
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Wallet" */ './views/Applicant/Wallet.vue')
    },
    {
      path: '/Exam',
      name: 'Exam',
      meta: {
        BannerClass: 'banner2',
        BoxClass: 'box2',
      },
      // lazy-loaded
      component: () => import( /* webpackChunkName: "Exam" */ './views/Applicant/Exam.vue')
    },

    {
      path: '/Welcome',
      name: 'welcome',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "welcome" */ './views/Applicant/Welcome.vue')
    },
    {
      path: '/paymentOrder',
      name: 'paymentOrder',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "paymentOrder" */ './components/Applicant/PaymentOrder.vue')
    },
         /** student Viwes for student Work   */
    {
      path: '/PersonalData',
      name: 'PersonalData',
      // lazy-loaded
      component: () => import( './views/academic/PersonalData.vue')
    },

    {
      path: '/Schedule',
      name: 'Schedule',
      // lazy-loaded
      component: () => import( './views/academic/Schedule.vue')
    },
    {
      path: '/CourseGrading',
      name: 'CourseGrading',
      // lazy-loaded
      component: () => import( './views/academic/CourseGrading.vue')
    },
    {
      path: '/Scholarship',
      name: 'Scholarship',
      // lazy-loaded
      component: () => import( './views/Financial/Scholarship.vue')
    },
    {
      path: '/Charges',
      name: 'Charges',
      // lazy-loaded
      component: () => import( './views/Financial/Charges.vue')
    },
    {
      path: '/StudentHistorySearch',
      name: 'StudentHistorySearch',
      // lazy-loaded
      component: () => import( './views/Financial/StudentHistorySearch.vue')
    },
    {
      path: '/CashReceipt',
      name: 'CashReceipt',
      // lazy-loaded
      component: () => import( './views/Financial/CashReceipt.vue')
    },
    {
      path: '/AllFinancial',
      name: 'AllFinancial',
      // lazy-loaded
      component: () => import( './views/Financial/AllFinancial.vue')
    },

    {
      path: '/SelectSubject',
      name: 'SelectSubject',
      // lazy-loaded
      component: () => import( './views/academic/SelectSubject.vue')
    },

    {
      path: '/transcript',
      name: 'transcript',
      // lazy-loaded
      component: () => import( './views/academic/transcript.vue')
    },

    {
      path: '/CreateStudentAccount',
      name: 'Create Student Account',
      // lazy-loaded
      component: () => import( './views/academic/CreateStudentAccount.vue')
    },

    {
      path: '/BasicSchedule',
      name: 'BasicSchedule',
      // lazy-loaded
      component: () => import( './views/academic/BasicSchedule.vue')
    },
    {
      path: '/Adviser',
      name: 'Adviser',
      // lazy-loaded
      component: () => import( './views/academic/Adviser.vue')
    },

    {
      path: '/event/:Serial',
      name: 'Event',
      // lazy-loaded
      component: () => import( './views/Event/event.vue')
    },
    {
      path: '/SearchResult',
      name: 'Search Result',
      // lazy-loaded
      component: () => import( './views/Event/SearchResult.vue')
    },
    {
      path: '/SelectEvent',
      name: 'Select Event',
      // lazy-loaded
      component: () => import( './views/Event/SelectEvent.vue')
    },
    {
      path: '/Request',
      name: 'Request',
      // lazy-loaded
      component: () => import( './views/OnLineRequest/Request.vue')
    },

    {
      path: '/transportation',
      name: 'transportation',
      // lazy-loaded
      component: () => import( './views/Transportations/transportation.vue')
    },

    {
      path: '/Dorms',
      name: 'Dorms',
      // lazy-loaded
      component: () => import( './views/Dorms/Dorms.vue')
    },




    {
      path: '*',
      name: 'NotFound',
      // lazy-loaded
      component: () => import( /* webpackChunkName: "NotFound" */ './views/NotFound.vue')
    }
    
  ]
});


// Router Guard for not logged in users . 
router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/ForgetPassword', '/welcome'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
    initFB(to) 
  if (authRequired && !loggedIn) {
    initFB(to) 
    next('/login');
  } else {

    if(process.env.NODE_ENV === "production") {
      initFB(to) 
      LoadGtag()
    }
     //initFB(to) // loading Facebook pixel

    next();
  }


});

// eslint-disable-next-line no-unused-vars
function initFB(to) {

  window.fbq = undefined
  if (to.path == '/register') {
    //<!-- Facebook Pixel Code -->
    LoadFB()
    window.fbq('init', `537835824725526`);
    window.fbq('track', 'PageView');
    //<!-- End Facebook Pixel Code -->
  } else if (to.path == '/login') {
    LoadFB()
    window.fbq('init', `537835824725526`);
    window.fbq('track', 'PageView');
  } else if (to.path == '/fawry') {
    LoadFB()
    window.fbq('init', `537835824725526`);
    window.fbq('track', 'PageView');
  } else {

        window.fbq = undefined
        window._fbq = undefined
  }

  function LoadFB(){
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
         else{
          n = f.fbq = function () {
            n.callMethod ?
              n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s)
         } 
        
      }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
       
    
  }
  
}
function LoadGtag(){
  let tag = document.createElement("script");
    tag.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=G-SQJQFBDRE6");
    tag.defer =true
    document.head.appendChild(tag);

  window.dataLayer = window.dataLayer || [];
function gtag(){
  window.dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'G-SQJQFBDRE6');
}